import { psmGet, psmPost, psmPut } from "../api/api";
import { collectPageRecords, normalizePageResponse } from "../lib/pagination";

const unwrapData = (response) => (response && response.data !== undefined ? response.data : response);

/** GET /tenant-announcements/search — PSM06S */
export async function searchTenantAnnouncements({ title = "", page = 0, size = 10 } = {}) {
  const params = new URLSearchParams({ page, size });
  if (title) params.set("title", title);
  const response = await psmGet(`/tenant-announcements/search?${params}`, "PSM06S");
  return normalizePageResponse(response, { page, size });
}

/** GET /tenant-announcements/{announcementId} — PSM06S */
export async function getTenantAnnouncement(announcementId) {
  return unwrapData(await psmGet(`/tenant-announcements/${announcementId}`, "PSM06S"));
}

/** POST /tenant-announcements/add — PSM06A */
export async function addTenantAnnouncement(payload) {
  return unwrapData(await psmPost("/tenant-announcements/add", payload, "PSM06A"));
}

/** PUT /tenant-announcements/update/{announcementId} — PSM06U */
export async function updateTenantAnnouncement(announcementId, payload) {
  return unwrapData(await psmPut(`/tenant-announcements/update/${announcementId}`, payload, "PSM06U"));
}

/** GET /tenant-registry/search/active-status?active=true — PSM01S (all pages) */
export async function getActiveTenants() {
  return collectPageRecords(
    (page, size) => psmGet(`/tenant-registry/search/active-status?active=true&page=${page}&size=${size}`, "PSM01S"),
    10
  );
}
